module.exports = __webpack_public_path__ + "img/decice1.7f020c11.png";